const QuestionStepperPanel = ({ children }: { children?: React.ReactNode }) => {
    return (
        <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            alignContent: "center",
            justifyItems: "center",
            flexDirection: "column",
            width: "100%",
            backgroundColor: "#faf7ef",
            paddingBottom: "2rem",
            borderRadius: "0px 0px 25px 25px"
        }}>
            {children}
        </div>
    );
}

export default QuestionStepperPanel;